export default "__VITE_ASSET__OEHNd$uD__"